import { render, staticRenderFns } from "./CommandmentsFilter.vue?vue&type=template&id=e2395480&scoped=true&"
import script from "./CommandmentsFilter.vue?vue&type=script&lang=js&"
export * from "./CommandmentsFilter.vue?vue&type=script&lang=js&"
import style0 from "./CommandmentsFilter.vue?vue&type=style&index=0&id=e2395480&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2395480",
  null
  
)

export default component.exports